var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 1.52C5.28075 1.52 3.888 1.99325 2.73 2.85575V1.25C2.73 0.83525 2.394 0.5 1.98 0.5C1.56525 0.5 1.23 0.83525 1.23 1.25V4.25C1.23 4.59425 1.464 4.8935 1.79775 4.97675L4.79775 5.72675C4.85925 5.7425 4.92075 5.75 4.98075 5.75C5.31675 5.75 5.622 5.52275 5.70675 5.1815C5.808 4.78025 5.5635 4.373 5.1615 4.2725L3.7965 3.93125C4.66125 3.34025 5.6805 3.02 6.75 3.02C9.64425 3.02 12 5.37575 12 8.27C12 11.1642 9.64425 13.52 6.75 13.52C3.85575 13.52 1.5 11.1642 1.5 8.27C1.5 7.85525 1.16475 7.52 0.75 7.52C0.33525 7.52 0 7.85525 0 8.27C0 11.9922 3.02775 15.02 6.75 15.02C10.4722 15.02 13.5 11.9922 13.5 8.27C13.5 4.54775 10.4722 1.52 6.75 1.52Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.c1d679debb10ede631814b8fd95c0ff2.svg";
export { ForwardRef as ReactComponent };